<template>
    <div>
    
        <div class="row justify-content-center card p-3">
                        <div class="row mb-3">
                <label for="faqEnabled" class="col-sm-2 col-form-label">Active?</label>
                <div class="col-sm-10">
                    <ToggleButton id="faqEnabled" class="form-control" v-model="translation.active"
                        onLabel="Enabled" offLabel="Disabled" />
                </div>
            </div>    
            <div class="row mb-3">
                <label for="languageCode" class="col-sm-2 col-form-label">Language Code</label>
                <div class="col-sm-10">
                    <InputText id="languageCode" v-model="translation.languageCode" class="form-control" />
                </div>
            </div>

            <div class="row mb-3">
                <label for="languageIdentifier" class="col-sm-2 col-form-label">Language Identifier</label>
                <div class="col-sm-10">
                    <InputText id="languageIdentifier" v-model="translation.languageIdentifier" class="form-control" />
                </div>
            </div>

            <div class="row mb-3">
                <label for="description" class="col-sm-2 col-form-label">Description</label>
                <div class="col-sm-10">
                    <InputText id="description" v-model="translation.description" class="form-control" />
                </div>
            </div>

            <div class="row mb-3">
                <label for="faqEnabled" class="col-sm-2 col-form-label">FAQ Enabled?</label>
                <div class="col-sm-10">
                    <ToggleButton id="faqEnabled" class="form-control" v-model="translation.faqEnabled"
                        onLabel="Enabled" offLabel="Disabled" />
                </div>
            </div>
            <div class="text-center mt-3">
                <Button :label="isNew ? 'Add' : 'Save'" class="p-button-tuev w-100" @click="saveTranslation">
                    <template #icon>
                        <font-awesome-icon :icon="['fas', 'save']" v-if="!isNew" />
                        <font-awesome-icon :icon="['fas', 'plus']" v-else />
                    </template>
                </Button>
            </div>


        </div>


    </div>

</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axiosInstance from '@/plugins/axios';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useToast } from 'primevue/usetoast';

const route = useRoute();
const router = useRouter();
const toast = useToast();
const isNew = route.params.id === 'new';

const translation = ref({
    languageCode: '',
    languageIdentifier: '',
    description: '',
    active: false,
    faqEnabled: true
});

const getTranslation = async () => {
    if (isNew) return;

    try {
        const response = await axiosInstance.get(`/admin/translations/${route.params.id}`);
        translation.value = response.data;
    } catch (error) {
        console.error('Error fetching translation:', error);
    }
};

const saveTranslation = async () => {
    try {
        if (isNew) {
            const response = await axiosInstance.post('/admin/translations', translation.value);
            toast.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Translation created successfully!',
                life: 3000
            });
            router.replace({ params: { id: response.data._id } }); 
        } else {
            await axiosInstance.put(`/admin/translations/${translation.value._id}`, translation.value);
            toast.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Translation updated successfully!',
                life: 3000
            });
        }
    } catch (error) {
        console.error('Error saving translation:', error);
        toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save translation.',
            life: 3000
        });
    }
};

onMounted(() => {
    getTranslation();
});

</script>

<style></style>